import { en } from './en'
import { fr } from './fr'

export const actionCard = {
  en,
  fr
}